import { LOCAL_STORAGE_USER_LOGIN_INFO, ORDER_BY } from '@app/constants/Common';
import { showMessage } from '@app/constants/Messages';
import {
    DVTJCUVCddOpenAndNotSddvBriefSentTabs,
    DVTJCUVCddOpenAndNotSddvNeedToMakeBriefTabs,
    DVTJCUVCddOpenAndNotSddvParentTabs
} from '@pages/dvtjcuv/common/CddOpenAndNotSddvTabs';
import UpdateDVTJCUVPipelineModal from "@pages/dvtjcuv/edit/UpdateDVTJCUVPipelineModal";
import DVTJCUVPipelineTableList, { DVTJCUVPipelineListMode } from "@pages/dvtjcuv/list/DVTJCUVPipelineTableList";
import HeaderSearchButtons from '@pages/dvtjcuv/rundvtjcuv/HeaderSearchButtons';
import RunDVTJCUVCandidateList from "@pages/dvtjcuv/rundvtjcuv/RunDVTJCUVCandidateList";
import InputCddGPEmpDiscussionModal from "@pages/dvtjcuv/rundvtjcuv/connectcddemp/InputCddGPEmpDiscussionModal";
import { requestGetDVTJCUVPipeLineList } from "@pages/dvtjcuv/service/DVTJCUVPipelineService";
import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';

const CddOpenAndNotSddvContent = (props) => {
    const [parentOfTab, setParentOfTab] = useState({});
    const [currentTab, setCurrentTab] = useState({});
    const [childTabList, setChildTabList] = useState([]);
    const [pipelineList, setPipelineList] = useState([]);
    const [dataInfo, setDataInfo] = useState({});
    const [mailTabData, setMailTabData] = useState({});
    const [showInputCddGPEmpDiscussion, setShowInputCddGPEmpDiscussion] = useState(false);
    const [showUpdatePipelineModal, setShowUpdatePipelineModal] = useState(false);
    const [selectPipeline, setSelectPipeline] = useState({});
    const [sortColumns, setSortColumns] = useState({
        created_date_time: ORDER_BY.DESC_UPDATE_DATE
    });
    const [userLoginInfo, setUserLoginInfo] = useState({});
    const [showBtnSearchPipeline, setShowBtnSearchPipeline] = useState(false);
    const [showBtnSearchCdd, setShowBtnSearchCdd] = useState(false);
    const [showBtnSearchReceiver, setShowBtnSearchReceiver] = useState(false);
    const [showBtnSearchEmployer, setShowBtnSearchEmployer] = useState(false);

    const {data, parentTab} = props;

    useEffect(() => {
        let loginUser = {};
        if (!userLoginInfo.id && localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)) {
            loginUser = JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO));
            setUserLoginInfo(loginUser);
        }
    }, []);

    const fetchPipeLines = async (pTab, subTab, sorts) => {
        const params = {
            search_conditions: {
                parent_tab: pTab?.id,
                sub_tab: subTab?.id || DVTJCUVCddOpenAndNotSddvBriefSentTabs.OFFERING_TAB.id,
                unlimited: true
            },
            sort_columns: sorts || {
                created_date_time: ORDER_BY.DESC_UPDATE_DATE
            }
        };

        const res = await requestGetDVTJCUVPipeLineList(params);
        const resContent = res.content;

        setPipelineList(resContent.pipelines);
    };

    const setTabContents = (pTab) => {
        let currTab = {};
        let childTabs = [];
        
        if (pTab.id === DVTJCUVCddOpenAndNotSddvParentTabs.BRIEF_SENT_TAB.id) {
            currTab = {...DVTJCUVCddOpenAndNotSddvBriefSentTabs.OFFERING_TAB};
            childTabs = Object.values(DVTJCUVCddOpenAndNotSddvBriefSentTabs);
            setShowBtnSearchCdd(true);
        } else if (pTab.id === DVTJCUVCddOpenAndNotSddvParentTabs.NEED_TO_MAKE_BRIEF_TAB.id) {
            currTab = {...DVTJCUVCddOpenAndNotSddvNeedToMakeBriefTabs.NOT_HAVE_BRIEF_TAB};
            childTabs = Object.values(DVTJCUVCddOpenAndNotSddvNeedToMakeBriefTabs);
            setShowBtnSearchCdd(true);
        } else if (pTab.id === DVTJCUVCddOpenAndNotSddvParentTabs.PRIORITY_PROCESS_TAB.id) {
            setShowBtnSearchPipeline(true);
            setShowBtnSearchCdd(true);
            setShowBtnSearchReceiver(true);
            setShowBtnSearchEmployer(true);
        } else if (pTab.id === DVTJCUVCddOpenAndNotSddvParentTabs.NEW_CDDS_TAB.id) {
            setShowBtnSearchCdd(true);
        }

        setParentOfTab(pTab);
        setCurrentTab(currTab);
        setChildTabList(childTabs);
    };

    useEffect(() => {
        if (parentTab) {
            fetchPipeLines(parentTab);
            setTabContents(parentTab);
        }
        if (data) {
            setDataInfo(data);
        }
    }, [data, parentTab]);

    const onTabClicked = async (tab) => {
        setCurrentTab({...tab});
        await fetchPipeLines(parentTab, tab);
    };

    const activeTab = (tab) => {
        if (currentTab.id === tab.id) {
            return 'active';
        }
        return '';
    };

    const onShowEditPipeline = (item, fromReferee) => {
        item.fromReferee = !!fromReferee;
        setSelectPipeline({...item});
        setShowUpdatePipelineModal(true);
    };

    const onInputGPEmpDiscussion = () => {
        setShowInputCddGPEmpDiscussion(true);
    };

    const onSort = async (columnKey) => {
        let newSorts = {...sortColumns};
        if (newSorts[columnKey] && newSorts[columnKey] === ORDER_BY.ASC) {
            newSorts[columnKey] = ORDER_BY.DESC;
        } else {
            newSorts = {};
            newSorts[columnKey] = ORDER_BY.ASC;
        }
        setSortColumns(newSorts);
        await fetchPipeLines(parentTab, currentTab, newSorts);
    };

    return (
        <>
            <div className="container-fluid">
                <div className="card card-default mt-3">
                    <div className="card-header">
                        <h3 className="card-title"><b>{parentOfTab.title}</b></h3>
                        <div className={"card-tools row"}>
                            {/* {parentOfTab.id !== DVTJCUVCddOpenAndNotSddvParentTabs.BRIEF_SENT_TAB.id && */}
                                <HeaderSearchButtons
                                    parentTabId={parentTab.id}
                                    tabId={currentTab.id}
                                    showBtnSearchPipeline={showBtnSearchPipeline}
                                    showBtnSearchCdd={showBtnSearchCdd}
                                    showBtnSearchReceiver={showBtnSearchReceiver}
                                    showBtnSearchEmployer={showBtnSearchEmployer}
                                />
                            {/* } */}
                            <Button variant='info' onClick={() => onInputGPEmpDiscussion()} className={'btn-sm ml-3'}>
                                Nhập Cdd-GP-Emp Discussion
                            </Button>
                        </div>
                    </div>

                    <div className="card-body p-0">
                        <>
                        {(parentOfTab?.id === DVTJCUVCddOpenAndNotSddvParentTabs.BRIEF_SENT_TAB.id
                            || parentOfTab?.id === DVTJCUVCddOpenAndNotSddvParentTabs.NEED_TO_MAKE_BRIEF_TAB.id
                        ) &&
                        <>
                            <ul className='nav nav-tabs' role='tablist'>
                                {childTabList.map(tab => (
                                    <li className='nav-item' key={`saved-list-tab-item-${tab.id}`}>
                                        <a className={`nav-link ${activeTab(tab)}`} data-toggle='tab' href={`#${tab.id}`}
                                           onClick={() => onTabClicked(tab)}>{tab.title} ({mailTabData[tab.id] ? mailTabData[tab.id] : 0})</a>
                                    </li>
                                ))}
                            </ul>
                            <div className='tab-content'>
                                {childTabList.map((tab, index) => {
                                    if (currentTab.id === tab.id) {
                                        if (parentOfTab?.id === DVTJCUVCddOpenAndNotSddvParentTabs.NEED_TO_MAKE_BRIEF_TAB.id) {
                                            return <div id={tab.id} className={`tab-pane ${activeTab(tab)}`}
                                                        style={{height: '83vh', overflow: 'auto'}}
                                                        key={`run-job-sub-tab-content-${parentTab.id}-${tab.id}`}>
                                                <RunDVTJCUVCandidateList runJob={dataInfo}
                                                                        //  inputCandidateIds={pipelineList.map(item => item.cdd_id)}
                                                                         onChangeTab={onTabClicked}
                                                                         parentTab={parentOfTab}
                                                                         subTab={currentTab}/>
                                            </div>
                                        }

                                        return <div id={tab.id} className={`tab-pane ${activeTab(tab)}`}
                                                    style={{height: '83vh', overflow: 'auto'}}
                                                    key={`run-dvtjcuv-sub-tab-content-${parentTab.id}-${tab.id}`}>
                                            <DVTJCUVPipelineTableList
                                                pipeLines={pipelineList}
                                                mode={DVTJCUVPipelineListMode.RUN_DVTJCUV_CONNECT_CDD_EMP}
                                                parentTabId={parentTab.id}
                                                onSort={onSort}
                                                sortColumn={sortColumns}
                                                subTabId={currentTab.id}
                                                onEditItem={(selectItem, fromReferee) => onShowEditPipeline(selectItem, fromReferee)}
                                            />
                                        </div>
                                    }
                                    return "";
                                    })
                                }
                            </div>
                        </>
                        }
                        {(parentOfTab.id === DVTJCUVCddOpenAndNotSddvParentTabs.PRIORITY_PROCESS_TAB.id
                        ) && (
                            <div className={'card card-default'}>
                                <div className='card-header'>
                                    <h3 className='card-title text-bold'>
                                        DVTJCUV pipelines
                                    </h3>
                                </div>
                                <div className='card-body'>
                                    <DVTJCUVPipelineTableList
                                        pipeLines={pipelineList}
                                        mode={DVTJCUVPipelineListMode.RUN_DVTJCUV_CONNECT_CDD_EMP}
                                        parentTabId={parentTab.id}
                                        subTabId={currentTab.id}
                                        onSort={onSort}
                                        sortColumn={sortColumns}
                                        onEditItem={(selectItem, fromReferee) => onShowEditPipeline(selectItem, fromReferee)}
                                    />
                                </div>
                            </div>
                        )}

                        {(parentOfTab.id === DVTJCUVCddOpenAndNotSddvParentTabs.NEW_CDDS_TAB.id) && (
                            <RunDVTJCUVCandidateList
                                runJob={dataInfo}
                                parentTab={parentOfTab}
                                subTab={currentTab}
                            />
                        )}
                        </>
                    </div>
                </div>
            </div>

            {showInputCddGPEmpDiscussion &&
                <InputCddGPEmpDiscussionModal
                    onClose={(success) => {
                        if (success) {
                            showMessage("Đã lưu Cdd-GP-Emp Discussion thành công.", false, true);
                        }
                        setShowInputCddGPEmpDiscussion(false);
                    }}
                    isShow={showInputCddGPEmpDiscussion}
                />
            }

            {showUpdatePipelineModal &&
                <UpdateDVTJCUVPipelineModal 
                    isShow={showUpdatePipelineModal}
                    pipeLineInfo={selectPipeline}
                    onClose={(reload) => setShowUpdatePipelineModal(false)}
                />
            }
        </>
    );
};

export default CddOpenAndNotSddvContent; 